import React from 'react';
import AdminUserManagement from '@/components/admin/AdminUserManagement';
import { useOptimizedAdminData } from '@/hooks/useOptimizedAdminData';
import { useAdminFilter } from '@/contexts/AdminFilterContext';
import { useAdminFilters } from '@/hooks/useAdminFilters';

const AdminUsersPage = () => {
  const { userTypeFilter } = useAdminFilter();
  const { 
    filters, 
    isOpen: filterOpen, 
    setIsOpen: setFilterOpen,
    updateFilter,
    clearFilters,
    getActiveFiltersCount
  } = useAdminFilters();

  const adminData = useOptimizedAdminData({ userTypeFilter, filters });

  return (
    <AdminUserManagement 
      users={adminData.users}
      loading={adminData.loading}
      refetch={adminData.refetch}
      loadMoreUsers={adminData.loadMoreUsers}
      hasMoreUsers={adminData.hasMoreUsers}
      loadingMore={adminData.loadingMore}
      totalUsers={adminData.stats.totalUsers}
      filters={filters}
      filterOpen={filterOpen}
      setFilterOpen={setFilterOpen}
      updateFilter={updateFilter}
      clearFilters={clearFilters}
      getActiveFiltersCount={getActiveFiltersCount}
    />
  );
};

export default AdminUsersPage;
